module.exports = __webpack_public_path__ + "img/TECNOLOGIA-VITARA-3.c462d1fb.jpg";